import { render, staticRenderFns } from "./CommonProductSelector.vue?vue&type=template&id=2f08c592&lang=pug&"
import script from "./CommonProductSelector.vue?vue&type=script&lang=ts&"
export * from "./CommonProductSelector.vue?vue&type=script&lang=ts&"
import style0 from "./CommonProductSelector.vue?vue&type=style&index=0&id=2f08c592&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports